import axiosInstance from 'helpers/axiosInstance';

import { Leads } from './leads.type';

interface LeadsResponse {
  leads: Leads;
}

export const getAccountLeads = async () => {
  const url = '/patients/leads';
  return axiosInstance.get<LeadsResponse>(url).then(r => r.data.leads);
};
